import React from "react";
import usePatients from "./usePatients";
import {API_URL, COLOR_SECONDARY} from "../../../../../config";
import DataTable from "../../../../../components/DataTable/DataTable";
import MDBox from "../../../../../components/MDBox";
import {NavLink} from "react-router-dom";
import moment from "moment";
import DateFilter from "../../../../../components/DateFilter/DateFilter";

const Patients = ({id}) => {
    const {actions} = usePatients();

    return (
            <MDBox mt={2} sx={{padding: 2, borderStyle: 'solid', borderWidth: 1, borderColor: '#e2e2e2', borderRadius: 2}}>
                <MDBox mb={3}>
                        <DataTable
                            endpoint={`${API_URL}/patients/doctor/${id}`}
                            title="Pacientes"
                            description="Pacientes asociados al perfil."
                            sortBy="name"
                            sortDirection="asc"
                            filter={true}
                            actions={actions}
                            colData={[
                                {
                                    name: 'id',
                                    label: 'ID',
                                    options: {
                                        display: 'excluded',
                                        filter: false
                                    }
                                },
                                {
                                    name: 'name',
                                    label: 'Nombre',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <NavLink to={`/pacientes/${tableMeta.rowData[0]}`}
                                                     key={`paciente-${tableMeta.rowData[0]}`}
                                                     style={{fontWeight: 500, color: COLOR_SECONDARY, textDecoration: 'underline'}}
                                            >
                                                {value} {tableMeta.rowData[2]} {tableMeta.rowData[3]}
                                            </NavLink>
                                        )
                                    }
                                },
                                {
                                    name: 'last_name',
                                    label: 'Apellido Paterno',
                                    options: {
                                        display: 'excluded'
                                    }
                                },
                                {
                                    name: 'mother_last_name',
                                    label: 'Apellido Materno',
                                    options: {
                                        display: 'excluded'
                                    }
                                },
                                {
                                    name: 'email',
                                    label: 'Correo',
                                },
                                {
                                    name: 'phone',
                                    label: 'Teléfono',
                                },
                                {
                                    name: 'created_at',
                                    label: 'Fecha',
                                    options: {
                                        filterType: 'custom',
                                        customFilterListOptions: {
                                            render: v => {
                                                if (v[0] && v[1]) return `Fecha: ${moment(v[0]).format('YYYY-MM-DD')} - ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                if (v[0]) return `Desde: ${moment(v[0]).format('YYYY-MM-DD')}`;
                                                if (v[1]) return `Hasta: ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                return false;
                                            },
                                            update: (filterList, filterPos, index) => {
                                                if (filterPos === 0) filterList[index].splice(filterPos, 1, '');
                                                else filterList[index] = [];
                                                return filterList;
                                            }
                                        },
                                        filterOptions: {
                                            names: [],
                                            display: (filterList, onChange, index, column) => <DateFilter filterList={filterList} column={column} onChange={onChange} index={index} />
                                        }
                                    }
                                },
                            ]}
                        />
                </MDBox>
            </MDBox>
    );
};

export default Patients;
